import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./css/bootstrap.min.css"; // Bootstrap CSS
import "./css/custom.css"; // Your other global CSS



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
